import * as React from "react";
const SvgClock = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20.965 12a8.965 8.965 0 1 0-17.93 0A8.965 8.965 0 0 0 12 20.965 8.965 8.965 0 0 0 20.965 12m-10-6a1.035 1.035 0 0 1 2.07 0v5.36l3.428 1.714a1.035 1.035 0 0 1-.926 1.852l-4-2a1.03 1.03 0 0 1-.572-.926zm12.07 6c0 6.095-4.94 11.035-11.035 11.035S.965 18.095.965 12 5.905.965 12 .965 23.035 5.905 23.035 12"
}));
export default SvgClock;
//# sourceMappingURL=Clock.js.map